<div class="row">
  <div class="col-12 products-container py-2">
    <div class="row py-3 mx-0 mb-3" style="background-color: #EAE8F5; border-radius: 8px;">
      <div class="col-12 col-lg-4 p-0">
        <div class="col-12 pl-2 text-left subtitle-section">Concepto y descripción</div>
      </div>
      <div class="col-12 col-lg-8 d-none d-lg-block">
        <div class="row">
          <div class="col-2 text-left subtitle-section">Cantidad</div>
          <div class="col-2 text-left subtitle-section">Precio</div>
          <div class="col-2 text-left subtitle-section">Subtotal</div>
          <div class="col-2 text-left subtitle-section">Impuestos(%)</div>
          <div class="col-2 text-left subtitle-section">Impuestos</div>
          <div class="col-2 pr-2 pl-0 text-left subtitle-section">Total</div>
        </div>
      </div>
    </div>

    <div class="row py-1 mx-0 my-2" *ngFor="let item of productItems" style="border-bottom: 1px solid #D2CFEB;">
      <div class="col-12 col-lg-4 p-0">
        <div class="col-12 text-left">
          <mat-form-field appearance="outline">
            <mat-label>Producto o Servicio</mat-label> <!--grandes cambios para no saltar error al migrar -->
            <input matInput type="text" [(ngModel)]="item.name" [readonly]="readOnly" style="width: 100%;"
              (ngModelChange)="onNameInputChange(item, $event)" placeholder="Producto o Servicio"
              [matAutocomplete]="autoProduct">
            <span *ngIf="item.addBy !== 'admin'" style="font-weight: 300;">
              (Añadido por trabajador)
            </span>
            <mat-autocomplete #autoProduct="matAutocomplete"
              (optionSelected)="newProductSelected(item, $event.option.value)">
              <mat-option *ngFor="let product of $products | async" [value]="product">
                {{ product.name }} {{ product.price | money : { needSymbol: true } }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>
      <div class="col-12 col-lg-8">
        <div class="row">
          <div class="col-6 col-md-2 pr-0 text-left">
            <mat-form-field appearance="outline">
              <mat-label>Cantidad</mat-label>
              <input matInput [value]="item.quantity | number:'1.3-3'" [(ngModel)]="item.quantity" [readonly]="readOnly"
                [placeholder]="'0'" (ngModelChange)="onQuantityChange(item, $event)">
            </mat-form-field>
          </div>
          <div class="col-6 col-md-2 text-left">
            <mat-form-field appearance="outline">
              <mat-label>Precio</mat-label>
              <input matInput [value]="item.price | number:'1.2-2'" [(ngModel)]="item.price" [readonly]="readOnly"
                [placeholder]="'0'" (ngModelChange)="onUnitPriceChange(item, $event)">
            </mat-form-field>
          </div>
          <div class="col-6 col-md-2 text-left">
            <mat-form-field appearance="outline">
              <mat-label>Subtotal</mat-label>
              <input matInput [value]="item.subtotal | number:'1.2-2'" [value]="item.subtotal" readonly>
            </mat-form-field>
          </div>
          <div class="col-6 col-md-2 text-left">
            <mat-form-field appearance="outline">
              <mat-label>Impuestos(%)</mat-label>
              <input matInput [value]="item.taxPercentage | number:'1.2-2'" [(ngModel)]="item.taxPercentage"
                [readonly]="readOnly" (ngModelChange)="calculateSubTotals(item)">
            </mat-form-field>
          </div>
          <div class="col-6 col-md-2 text-left">
            <mat-form-field appearance="outline">
              <mat-label>Impuestos</mat-label>
              <input matInput [value]="item.tax || 0 | money : { needSymbol:false }" [readonly]="!readOnly">
            </mat-form-field>
          </div>
          <div class="col-6 col-md-2 text-left">
            <mat-form-field appearance="outline">
              <mat-label>Total</mat-label>
              <input matInput [value]="item.total || 0 | money : { needSymbol:true }" [readonly]="!readOnly">
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <div class="row py-1 mx-0">
      <div class="col-4">
        <button class="btn btn-outline-manax" (click)="newProduct()">
          <i class="material-icons mr-1">add</i>
          Añadir línea:
        </button>
      </div>
      <div class="col-12 p-0">
        <!-- <app-product-autocomplete [text]="'mandale'" (changed)="cambio($event)" (selected)="cambio($event)">
        </app-product-autocomplete> -->
        <!-- <app-detail-list [items]="productItems" (listChange)="onListChange($event)">
        </app-detail-list> -->
      </div>
    </div>
    <!-- <table>
      <thead>
        <tr>
          <th>Concepto</th>
          <th class="d-none d-md-table-cell text-right">Cantidad</th>
          <th class="d-none d-md-table-cell text-right">Unitario {{curr}}</th>
          <th class="d-none d-md-table-cell text-right">Total {{curr}}</th>
          <th width="1%">&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of productItems">


          <td class="d-table-cell d-none" style="font-weight: 600;">
            <input [value]="item.name || item.product?.name" [readonly]="readOnly" style="width: 100%;"
              [material]="false" (input)="onNameInputChange(item, $event.target.value)">

            <span *ngIf="item.addBy!=='admin'" style="font-weight: 300;">
              (Añadido por trabajador)
            </span>
            <div class="d-table-cell d-md-none small">
              Cant:
              <app-input-decimal [decimals]="3" [initValue]="item.quantity" [readonly]="readOnly" [placeholder]="'0'"
                [material]="false" (updated)="onQuantityChange(item, $event)">
              </app-input-decimal>
              Unitario:
              <app-input-decimal [decimals]="2" [initValue]="item.price" [readonly]="readOnly" [placeholder]="'0'"
                [material]="false" (updated)="onUnitPriceChange(item, $event)">
              </app-input-decimal>
              Total: {{item.quantity * item.price | money : { needSymbol:true } }}
            </div>
          </td>



          <td class="d-none d-md-table-cell text-right">
            <app-input-decimal [decimals]="3" [initValue]="item.quantity" [readonly]="readOnly" [placeholder]="'0'"
              [material]="false" (updated)="onQuantityChange(item, $event)">
            </app-input-decimal>
          </td>
          <td class=" d-none d-md-table-cell text-right">
            <app-input-decimal [decimals]="2" [initValue]="item.price" [readonly]="readOnly" [placeholder]="'0'"
              [material]="false" (updated)="onUnitPriceChange(item, $event)">
            </app-input-decimal>
          </td>
          <td class="d-none d-md-table-cell text-right">{{item.quantity * item.price | money : { needSymbol:true } }}
          </td>
          <td>
            <button type="button" class="btn btn-link text-danger m-0 ml-2 p-0" (click)="removeItem(item)"
              *ngIf="!readOnly">
              <i class="material-icons">delete</i>
            </button>
          </td>
        </tr>
        <tr *ngIf="status !== 'INVOICED'">
          <td>
            <br><b>Añadir línea:</b><br>
            <div class="field-container">
              <input type="text"[placeholder]="'0'"car..." [formControl]="myControl" [matAutocomplete]="autoProduct"
                [readonly]="readOnly" class="product-search">
              <mat-autocomplete #autoProduct="matAutocomplete"
                (optionSelected)="newProductSelected($event.option.value)">
                <mat-option *ngFor="let product of $products | async" [value]="product">
                  {{product.name}} {{product.price | money : { needSymbol:true } }}
                  <span *ngIf="product?.category?.name">
                    ({{ product?.category?.name }})
                  </span>
                </mat-option>
              </mat-autocomplete>
              <span class="field-actions">
                <button type="button" class="btn btn-link text-lavuro mx-1 p-1" (click)="openNewProductModal()"
                  *ngIf="!readOnly">
                  <i class="material-icons">add</i> Nuevo Producto o Servicio
                </button>
              </span>
            </div>
          </td>
        </tr>
      </tbody>
    </table><br> -->

    <div class="row">
      <div class="col-md-4"></div>
      <div
        class="col-12 col-sm-3 col-md-2 text-center d-flex flex-column align-items-center justify-content-center order-md-last">
        <div class="item-valor">
          <b>Subtotal:</b>
          <b>{{totals.subtotal | money : { needSymbol:true } }}</b>
        </div>
      </div>
      <div class="col-6 col-sm-3 col-md-2 text-right">
        <b>Impuestos&nbsp;(%):</b><br>
        <app-input-decimal [decimals]="2" [initValue]="taxPercentage" [readonly]="readOnly" style="width: 70px;"
          [placeholder]="'0'" [material]="false" (updated)="taxPercentageChanged($event)">
        </app-input-decimal>
      </div>
      <div class="col-6 col-sm-3 col-md-2 text-right">
        <b>Impuestos:</b><br>
        {{totals.tax | money : { needSymbol:true } }}
      </div>
      <div class="col-12 col-sm-3 col-md-2 text-right">
        <b>TOTAL:</b><br>
        {{totals.total | money : { needSymbol:true } }}
      </div>
    </div>
  </div>
</div>